import { atomWithStorage } from "jotai/utils";
import { StoreKeys } from "./store-keys";
/**
 * Interface for empresa data
 */
export interface Dates {
  fromDate: string;
  toDate: string;
}

export const categoriesAtom = atomWithStorage<number[] | null>(
  `Xtremis_CarbonTech_${StoreKeys.Categories}`,
  null,
);
